import { CALENDAR_CARD_BORDER } from './calendar.constants';

const DAYS_TO_SHOW = 5;
const ITEMS_PER_DAY = [2, 0, 3, 1, 2];
const ITEM_WIDTHS = ['60%', '75%', '50%', '85%', '70%'];
const DELAYS = ['0ms', '100ms', '200ms', '300ms', '400ms'];

interface AgendaItemSkeletonProps {
  width: string;
  delay: string;
}

const AgendaItemSkeleton = ({ width, delay }: AgendaItemSkeletonProps) => (
  <div className="flex items-center gap-3 p-3 rounded-lg">
    <div
      className="w-2 h-12 rounded-sm animate-pulse motion-reduce:animate-none bg-bg-disabled-subtle"
      style={{ animationDelay: delay }}
    />
    <div className="flex-1 flex flex-col gap-2">
      <div
        className="h-4 rounded animate-pulse motion-reduce:animate-none bg-bg-disabled-subtle"
        style={{ width, animationDelay: delay }}
      />
      <div className="flex gap-4">
        <div
          className="h-3 w-24 rounded animate-pulse motion-reduce:animate-none bg-bg-disabled-subtle"
          style={{ animationDelay: delay }}
        />
        <div
          className="h-3 w-20 rounded animate-pulse motion-reduce:animate-none bg-bg-disabled-subtle"
          style={{ animationDelay: delay }}
        />
      </div>
    </div>
  </div>
);

const AgendaSkeleton = () => {
  let itemIndex = 0;

  return (
    <div
      className="flex flex-col flex-1 min-h-0 overflow-hidden bg-white rounded-lg border p-6 gap-6"
      style={{ borderColor: CALENDAR_CARD_BORDER }}
    >
      <div className="flex flex-col flex-1 min-h-0 overflow-hidden gap-6">
        {ITEMS_PER_DAY.map((itemCount, dayIndex) => {
          const dayDelay = DELAYS[dayIndex % DELAYS.length]!;

          if (itemCount === 0) return null;

          return (
            <div key={dayIndex} className="flex w-full gap-6">
              <div className="shrink-0 flex flex-col w-[276px] min-h-[70px] p-2">
                <div
                  className="h-5 w-32 rounded animate-pulse motion-reduce:animate-none bg-bg-disabled-subtle"
                  style={{ animationDelay: dayDelay }}
                />
              </div>

              <div className="flex flex-col flex-1 min-w-0 gap-1">
                {Array.from({ length: itemCount }).map((_, idx) => {
                  const currentItemIndex = itemIndex++;
                  return (
                    <AgendaItemSkeleton
                      key={`${dayIndex}-${idx}`}
                      width={
                        ITEM_WIDTHS[currentItemIndex % ITEM_WIDTHS.length]!
                      }
                      delay={DELAYS[(currentItemIndex * 2) % DELAYS.length]!}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AgendaSkeleton;
